const Data = {
  WebsiteTitle: "Yun-Tzu Chang",
  HeaderTitle: "Yun-Tzu Chang",
  FooterText: "",
  AboutEmail: "yuntz.c@gmail.com",
  AboutEmailSubject: "Subject of the Email",
  AboutHeading: "Bio",
  AboutTextParagraph1: "Yun-Tzu Chang is a Seattle-based sculptor from Taiwan. Her journey began with manga character figures exhibited at Tokyo's Wonder Festival in the early 2010s. While working as a software engineer, she has evolved from pop culture-inspired resin figures to mixed-media ceramics, exploring psychological states through surreal abstraction. Drawing on her engineering background, she designs with intentionality, focusing on clear concepts and structure. Her work merges figurative realism with abstract elements, inviting viewers into emotional landscapes shaped by themes of confinement, isolation, and hope.\n\n",
  AboutHeading2: "Artist Statement",
  AboutTextParagraph2: "I create sculptures that give form to internal tension—conflicts between freedom and restraint, connection and solitude. My figures, inspired by live models or imagined characters, shift into surreal forms that visualize psychological states. Abstraction allows me to express what the figure alone can't—confining walls, openings that suggest escape, spaces that unsettle. I aim to raise questions, inviting reflection without offering answers.",
  AboutButtonText: "About",
  // Social Media
  InstagramHandle: "ychang_art", // Replace with your actual Instagram handle
  SocialLinks: {
    instagram: "https://www.instagram.com/ychang_art/", // Replace with your actual Instagram URL
    email: "yuntz.c@gmail.com"
  }
};

export default Data;
